module.exports = __webpack_public_path__ + "img/kc6.0b1901be.png";